import { Box, Typography } from '@mui/material';
import { t } from '../../../constants/helperTranslations';
import { useLocale } from '../../../contexts/locale.context';

const KitchenHelper = () => {
  const { lang } = useLocale();

  return (
    <Box>
      <Typography sx={{ mb: 1 }}>{t.kitchen_screen_section[lang]}</Typography>

      <Box component="ul" sx={{ mb: 2, mt: 0 }}>
        <Typography component="li" sx={{ mb: 1 }}>
          {t.order_receiving[lang]}
        </Typography>
        <Typography component="li" sx={{ mb: 1 }}>
          {t.order_statuses[lang]}
        </Typography>
        <Typography component="li" sx={{ mb: 1 }}>
          {t.semi_finished_products[lang]}
        </Typography>
        <Typography component="li" sx={{ mb: 1 }}>
          {t.preparation_timing[lang]}
        </Typography>
      </Box>

      <Typography sx={{ mb: 2 }}>{t.kitchen_screen_usage[lang]}</Typography>

      <Box sx={{ height: 2 }} />
    </Box>
  );
};

export default KitchenHelper;
